import {useContext, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {AppContext} from '../context/AppProvider';
import {SubscriptionsType} from '../interface';
import {verifySubscription} from '../services/subscriptions';
import {APPROUTES, SubscriptionStatus} from '../assets/constants/constants';
//
const useSubscription = () => {
  const location = useLocation();
  const {state, dispatch} = useContext(AppContext);
  const [subscriptionResponse, setSubscriptionResponse] = useState<SubscriptionsType>();
  const navigate = useNavigate();
  const callSubscription = async (type?: string) => {
    verifySubscription()
      .then((res: any) => {
        if (res.status === 200) {
          if (res.data.subscriptionStatus === SubscriptionStatus.active || res.data.subscriptionStatus === SubscriptionStatus.trial) {
            setSubscriptionResponse(res.data);
            if(res.data.subscriptionStatus === SubscriptionStatus.active){
              dispatch({type: 'SET_SUBSCRIPTION', payload: true});
              if (location.pathname === APPROUTES.selectCurrency || location.pathname === APPROUTES.selectMembership) {
                navigate(APPROUTES.home);
              }
            }else  if(res.data.subscriptionStatus === SubscriptionStatus.trial){
              if ( state.isAuthenticated === true && (location.pathname === APPROUTES.userSettings || location.pathname === '/user-settings/notification')) {
                navigate(location.pathname);
              }
            }else{
              if (!type) {
                navigate(APPROUTES.home);
              }
            }
          } else if (res.data.subscriptionStatus === SubscriptionStatus.trialOver) {
            setSubscriptionResponse(res.data);
            if (location.pathname === APPROUTES.selectMembership){
              dispatch({type: 'SET_SUBSCRIPTION', payload: false});
            }else{
                navigate(APPROUTES.selectCurrency);
            }
          } else if (res.data.subscriptionStatus === SubscriptionStatus.canceled) {
            dispatch({type: 'SET_SUBSCRIPTION', payload: false});
            setSubscriptionResponse(res.data);
            dispatch({type: 'IS_AUTH', payload: false});
            navigate('/');
          } else if (res.data.subscriptionStatus === SubscriptionStatus.pending) {
            dispatch({type: 'IS_AUTH', payload: true});
            dispatch({type: 'SET_SUBSCRIPTION', payload: false});
            setSubscriptionResponse(res.data);
            if (location.pathname === '/') navigate(APPROUTES.selectCurrency);
            else  navigate(APPROUTES.selectMembership);
          } else {
            dispatch({type: 'SET_SUBSCRIPTION', payload: false});
            if (state.user) {
              dispatch({type: 'IS_AUTH', payload: false});
              navigate('/');
            } else {
              dispatch({type: 'IS_AUTH', payload: true});
              navigate(APPROUTES.selectMembership);
            }
            setSubscriptionResponse(res.data);
          }
          return Promise.resolve(true);
        } else {
          dispatch({type: 'IS_AUTH', payload: false});
          navigate('/');
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  return {
    callSubscription,
    subscriptionResponse,
  };
};
export default useSubscription;
